export default __webpack_public_path__ + "static/media/Tails.10e41bbd.png";